//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React from 'react';

const ArrowIcon = () => (
  <svg
    role="img"
    aria-label="Arrow Icon"
    width="14"
    height="12"
    viewBox="0 0 14 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.125 0.375L7.32062 1.15856L11.5844 5.4375H0.25V6.5625H11.5844L7.32062 10.8223L8.125 11.625L13.75 6L8.125 0.375Z"
      fill="#0550DC"
    />
  </svg>
);

export default ArrowIcon;
